import { Component, Input } from '@angular/core';

import { PaymentLinkComponent } from '../../payment-link.component';

/**
 * "the_portrait" view of /payment-link.
 *
 * Uses <qrcode>, whose colours are configurable, but is still rendered dark-on-light on a
 * white plate to match the other methods and to keep every code scannable.
 */
@Component({
  selector: 'app-payment-link-portrait',
  templateUrl: './payment-link-portrait.component.html',
  styleUrls: ['./payment-link-portrait.component.scss']
})
export class PaymentLinkPortraitComponent {

  @Input() host!: PaymentLinkComponent;

}
